module.exports = __webpack_public_path__ + "static/rendition-hd-example-c75e5e2a6f03f2d2c60d470d77d83677.mp4";